import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
// import { fetchPolicyHolderInfo, loadingUser } from '../action';
import "../../styles/theme.scss";
import {useTranslation} from "react-i18next";
import {Button, Grid, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import ClaimFIlter from "./ClaimFIlter";
// import ClaimTable from "./ClaimTable";
import {useNavigate} from "react-router-dom";
import {loadingUser} from "../../action";
import MedicalItemsTable from "./MedicalItemsTable";
import MedicalItemsFilter from "./MedicalItemsFilter";

function MedicalItemsTab() {
  const token = localStorage.getItem("token");
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [insureeCheck, setInsureeCheck] = useState(false);
  const [insureeData, setInsureeData] = useState();
  const [filter, setFilter] = useState([]);
  const userData = useSelector((state) => state.profileReducer);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate])

  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);

  return (
    <Grid container>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={goBack}
        style={{ color: "black" }}
      >
        {t("Retour aux informations de la FOSA")}
      </Button>
      <Grid container display="flex" justifyContent="space-between">
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#000",
            marginLeft: "20px",
          }}
        >
          Liste des produits médicaux
        </Typography>
        <Grid style={{marginRight: "20px"}}>

        </Grid>
      </Grid>

      <MedicalItemsFilter
        setFilter={setFilter}
        filter={filter}
      />
      <MedicalItemsTable
        filter={filter}
        setInsureeData={setInsureeData}
        insureeCheck={insureeCheck}
      /> 
    </Grid>
  );
}

export default MedicalItemsTab;
